// src/translation.ts
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json";
import translationEs from "./locales/es/translation.json";
import translationFr from "./locales/fr/translation.json";
import translationDe from "./locales/de/translation.json";
import translationIt from "./locales/it/translation.json";
import translationDa from "./locales/da/translation.json";
import translationSv from "./locales/sv/translation.json";
import translationNo from "./locales/no/translation.json";
import translationNl from "./locales/nl/translation.json";

// Define the supported languages
const supportedLanguages = ['en', 'es', 'fr', 'de', 'it', 'da', 'sv', 'no', 'nl'];

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: true,
    lng: "en",
    fallbackLng: "en",
    
    detection: {
      // Check in this order
      order: ['path', 'localStorage', 'navigator', 'querystring', 'cookie', 'htmlTag'],
      
      // Look for language in the URL path
      lookupFromPathIndex: 0,
      
      // Cache user language preference
      caches: ['localStorage'],
      
      // Look for 'lang' parameter in URLs (e.g., ?lang=es)
      lookupQuerystring: 'lang',
    },

    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      es: {
        translations: translationEs,
      },
      fr: {
        translations: translationFr,
      },
      de: {
        translations: translationDe,
      },
      it: {
        translations: translationIt,
      },
      da: {
        translations: translationDa,
      },
      sv: {
        translations: translationSv,
      },
      no: {
        translations: translationNo,
      },
      nl: {
        translations: translationNl,
      }
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

// Store supported languages in a global variable that we can access without modifying the i18n interface
const supportedLangs = supportedLanguages;

// Export a function to check if a language code is supported
export const isSupportedLanguage = (code: string): boolean => {
  return supportedLangs.includes(code);
};

export { supportedLangs };
export default i18n;